import { render, staticRenderFns } from "./wShopping.vue?vue&type=template&id=f404e702&scoped=true&"
import script from "./wShopping.vue?vue&type=script&lang=js&"
export * from "./wShopping.vue?vue&type=script&lang=js&"
import style0 from "./wShopping.vue?vue&type=style&index=0&id=f404e702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f404e702",
  null
  
)

export default component.exports